import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import QuestionnairesSkeleton from "./Questionnaires.skeleton";
import QuestionnairesTable from "./components/QuestionnairesTable";

import { useGetCsobFormsMetadata } from "@api";
import { Typography } from "@components/base";
import { useUserStore } from "@store/user";

const CsobHubQuestionnaires: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { availableFormsMetadata } = useGetCsobFormsMetadata(user);
  const { isLoadingFormsMetadata, formsError } = useGetCsobFormsMetadata(user);

  return (
    <>
      {isLoadingFormsMetadata ? (
        <QuestionnairesSkeleton />
      ) : formsError ? (
        <Typography color="error">{t("error.loadingForms")}</Typography>
      ) : availableFormsMetadata && availableFormsMetadata.length > 0 ? (
        <QuestionnairesTable />
      ) : null}
    </>
  );
};

export default CsobHubQuestionnaires;
